module.exports = __webpack_public_path__ + "images/marek.jpg?v=cc9aae48081ba8865c1ac49eb001cdea";